import { render, staticRenderFns } from "./MlivingVideoView.vue?vue&type=template&id=af2f07c8&"
import script from "./MlivingVideoView.vue?vue&type=script&lang=js&"
export * from "./MlivingVideoView.vue?vue&type=script&lang=js&"
import style0 from "./MlivingVideoView.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports